export function VoiceTemplatePlayIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#101828" />
      <path d="M25.2142 21.1204C24.9762 22.1052 23.8512 22.8012 21.6012 24.1932C19.426 25.5386 18.3386 26.2115 17.4621 25.9411C17.0998 25.8292 16.7696 25.6169 16.5034 25.3243C15.8594 24.6168 15.8594 23.2445 15.8594 20.5C15.8594 17.7555 15.8594 16.3831 16.5034 15.6756C16.7696 15.3831 17.0998 15.1708 17.4621 15.059C18.3386 14.7885 19.426 15.4613 21.6012 16.8068C23.8512 18.1988 24.9762 18.8948 25.2142 19.8796C25.3124 20.2861 25.3124 20.7139 25.2142 21.1204Z" fill="white" stroke="white" stroke-width="3.14285" stroke-linejoin="round" />
    </svg>
  );
}

VoiceTemplatePlayIcon.displayName = 'VoiceTemplatePlayIcon';
